<template>
    <div class="news-container">
        <div class="news-box">
            <div class="news-left-container">
                <!-- 轮播图 -->
                <div class="carousel-container">
                    <el-carousel height="320px" :interval="5500" @change="carouselChange">
                        <el-carousel-item v-for="item in bannerList" :key="item.id">
                            <img :src="item.cover" alt="" style="width: 100%;height:100%;object-fit: cover;">
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="main-article-title">{{ bannerTitle }}</div>
                <div class="news-tabs-container">
                    <el-tabs class="new-tabs" v-model="tabActiveName" @tab-click="handleTabClick">
                        <el-tab-pane label="最新文章" name="0"></el-tab-pane>
                        <el-tab-pane label="基础教程" name="2"></el-tab-pane>
                        <el-tab-pane label="赚钱线索" name="3"></el-tab-pane>
                        <el-tab-pane label="行业资讯" name="1"></el-tab-pane>
                    </el-tabs>
                    <div class="news-list-container">
                        <NewsItemHorizon v-for="item in newsList" :key="item.id" :news-info="item"
                            @toViewDetail="toViewDetail"></NewsItemHorizon>
                    </div>
                </div>
                <div class="pagination-container">
                    <el-pagination background :hide-on-single-page="true" layout="prev, pager, next"
                        :page-size="pageSize" :total="newsTotal" @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
            <div class="news-right-container">
                <div class="search-container">
                    <el-input class="search-input" placeholder="请输入关键词" v-model="searchWord" clearable
                        prefix-icon="el-icon-search" @keyup.enter.native="toSearchHotRead">
                    </el-input>
                </div>
                <div class="hotread-container">
                    <div class="hotread-title-img">
                        <img src="../../assets/news.svg" alt="">
                        <span class="hotread-title">热门阅读</span>
                    </div>
                    <div v-for="(item,index) in hotReadList" :key="item.id" class="hotread-result-item">
                        <NewsItemVertical :news-info="item" @toViewDetail="toViewDetail" />
                    </div>
                </div>
            </div>
        </div>
        <div class="contact-box">
            <Contact />
        </div>
    </div>
</template>

<script>
    import Contact from "@/components/Contact"
    import NewsItemHorizon from "@/components/NewsItemHorizon"
    import NewsItemVertical from "@/components/NewsItemVertical"
    import { getArticleList } from "@/api/home"
     import { mapState } from 'vuex'

    export default {
        name: 'News',
        components: { Contact, NewsItemHorizon, NewsItemVertical },
        data() {
            return {
                bannerList: [{
                    id: 1,
                    image: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fp4.itc.cn%2Fimages01%2F20201122%2Fdcb073c1f9c94328aaeb99a78caabda3.jpeg&refer=http%3A%2F%2Fp4.itc.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1662473826&t=8534208f06e87196b60ac58f0c075052'
                }],
                bannerTitle:'',
                tabActiveName: '0',
                newsList: [],
                newsTotal: 0,
                currentPage: 1,
                pageSize: 15,
                searchWord: '',
                hotReadList: []
            }
        },
        computed:{
            ...mapState("articleCategory",['articleCategory','articleTypeId'])
        },
        async created() {
            window.scrollTo(0, 0)
            // 最新文章
            if(this.articleTypeId != null) {
                this.tabActiveName = this.articleTypeId.toString()
                this.handleTabClick()
            }else {
                // 最新文章
                this.newsList = await this.getArticleList({
                    type_id: ''
                })
            }
            this.hotReadList = await this.getArticleList({
                type_id: '',
                sort: 'view_count',
                size: 7
            }, false)
            this.getBannerList()

        },
        mounted() {
            // console.log(this.$bus.sendData,'mounted')
            this.$bus.$off('getArticleListByCategory').$on('getArticleListByCategory',data=>{
                console.log('类型数据接收',data);
                this.tabActiveName = data.toString()
                this.handleTabClick()
            });
        },
        methods: {
            carouselChange(index) {
                this.bannerTitle = this.bannerList[index].title
            },
            getBannerList() {
                getArticleList({
                    is_banner: 1
                }).then(res => {
                    if (res.data.data && res.data.data.length) {
                        this.bannerList = res.data.data
                        this.bannerTitle = res.data.data[0].title
                    }
                })
            },
            toViewDetail(newsItem) {
                this.$router.push({
                    name: 'NewsDetail',
                    params: {
                        id: newsItem.id
                    }
                })
            },
            async toSearchHotRead() {
                this.hotReadList = await this.getArticleList({
                    type_id: '',
                    sort: 'view_count',
                    keyword: this.searchWord,
                    size: 7
                })
            },
            async handleTabClick(tab) {
                //TO DO 获取不同类型的文章列表
                const type = this.tabActiveName === '0' ? '' : +this.tabActiveName
                this.newsList = await this.getArticleList({
                    type_id: type,
                    current_page: 1
                })
            },
            async handleCurrentChange(val) {
                const type = this.tabActiveName === '0' ? '' : +this.tabActiveName
                this.newsList = await this.getArticleList({
                    type_id: type,
                    current_page: val
                })
            },
            getArticleList(params = {},needTotal=true) {
                return new Promise((resolve, reject) => {
                    getArticleList({
                        current_page: this.currentPage,
                        ...params
                    }).then(res => {
                        if(needTotal = true) {
                            this.newsTotal = res.data.total
                            console.log(this.newsTotal,'newsTotal')
                        }
                        if (res.data.data) {
                            resolve(res.data.data)
                        }
                    })
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/styles/mixin.less";
    @import "~@/styles/var.less";

    .news-container {
        width: 100%;
    }

    .news-box {
        width: 1200px;
        display: flex;
        margin: 25px auto 73px;
    }

    .news-left-container {
        width: 846px;
        margin-right: 40px;
    }

    .carousel-container {
        height: 320x;
        border-radius: 20px;
        overflow: hidden;
        z-index: 10;
        position: relative;
    }

    .main-article-title {
        font-size: 18px;
        font-weight: 600;
        color: @words;
        margin-top: 12px;
        .line-clamp()
    }

    .news-tabs-container {
        margin-top: 33px;
    }

    .news-list-container {
        margin-top: 34px;
        margin-bottom: 76px;
    }

    .pagination-container {
        display: flex;
        justify-content: center;
    }

    .news-right-container {
        width: 314px;
    }

    .hotread-container {
        width: 100%;
        background: #FFFFFF;
        border-radius: 20px;
        overflow: hidden;
        margin-top: 25px;
        padding-bottom: 33px;
    }

    .hotread-title-img {
        display: flex;
        align-items: center;
        padding: 32px 0 0 41px;
    }

    .hotread-title-img img {
        margin-right: 10px;
        object-fit: cover;
    }

    .hotread-title {
        font-size: 20px;
        font-weight: 600;
        color: @words;
    }

    .hotread-result-item {
        width: 250px;
        margin: 33px auto 0;
    }

    .contact-box {
        .contact-box()
    }
</style>
<style lang="less">
    @import "~@/styles/var.less";

    .new-tabs .el-tabs__header {
        margin: 0;
    }

    .search-input input {
        border: 2px solid #3998FE;
        overflow: hidden;
        border-radius: 14px;
        color: @words;
        font-size: 16px;
    }

    .search-input input::placeholder {
        color: #D6D6D6;
        font-size: 16px;
    }

    .search-input .el-input__prefix {
        color: #D6D6D6;
    }

    .search-input .el-input__inner {
        height: 50px;
        line-height: 50px;
    }
</style>